import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=e8cab0d0&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=e8cab0d0&prod&lang=css"
import style1 from "./ContentItem.vue?vue&type=style&index=1&id=e8cab0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cab0d0",
  null
  
)

export default component.exports